import React from 'react';



type Props = {
  className?: string;
}
export const CalculatorVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path d = 'M20 21H5V3H19V18M8 7H16M15 13V18M11 14H13M11 11H13M14 11H16M8 11H10M8 14H10M8 17H10M11 17H13' stroke='currentColor' strokeWidth='2'/>
    </svg>
  );
};
